<template>
  <div>
    <slot :text="cyclicPlaceholder" />
  </div>
</template>

<script>
export default {
  name: 'CyclicPlaceholder',

  props: {
    overrideText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      placeholders: [
        'Ask me about the markets',
        'Ask me about commodity prices',
        'Ask me about crop conditions',
      ],
      placeholderInterval: null,
      currentPlaceholderIndex: 0,
    };
  },

  computed: {
    cyclicPlaceholder() {
      if (this.overrideText) {
        return this.overrideText;
      }
      return this.placeholders[this.currentPlaceholderIndex];
    },
  },

  mounted() {
    this.startCyclicPlaceholders();
  },

  beforeDestroy() {
    clearInterval(this.placeholderInterval);
  },

  methods: {
    startCyclicPlaceholders() {
      this.placeholderInterval = setInterval(() => {
        this.currentPlaceholderIndex = (this.currentPlaceholderIndex + 1) % this.placeholders.length;
      }, 3000);
    },
  },
};
</script>
